import React from "react";

import "./specific-area.style.scss";
import { GlobalContext } from "../../GlobalState";
import http from "../../api/http";

class SpecificArea extends React.Component {
  state = {
    style: "hover_group",
    coordsRefIsActive: {},
    isSpaceClicked: false,
    imageUrl: null,
    isImageLoading: false,
    loadedImg: null,
    loadedSchoolCode: null,
  };

  objectUrl = null;

  componentDidMount() {
    this.syncCoordsState();
    this.loadImageIfNeeded();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.coordinates !== this.props.coordinates) {
      this.syncCoordsState();
    }

    const currentSchoolCode = this.context.selectedSchoolCode;
    const schoolChanged = prevState.loadedSchoolCode !== currentSchoolCode;
    const imageChanged = prevState.loadedImg !== this.props.img;

    if (schoolChanged || imageChanged) {
      this.loadImageIfNeeded();
    }
  }

  componentWillUnmount() {
    this.revokeObjectUrl();
  }

  syncCoordsState = () => {
    const coordsRefIsActive = {};
    this.props.coordinates.forEach((coords) => {
      coordsRefIsActive[coords.id] = false;
    });

    this.setState({
      coordsRefIsActive,
      isSpaceClicked: false,
    });
  };

  revokeObjectUrl = () => {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
    }
  };

  loadImageIfNeeded = async () => {
    const { img } = this.props;
    const selectedSchoolCode = this.context.selectedSchoolCode;
    const { loadedImg, loadedSchoolCode, isImageLoading } = this.state;

    if (!img || !selectedSchoolCode) return;
    if (isImageLoading) return;
    if (loadedImg === img && loadedSchoolCode === selectedSchoolCode) return;

    try {
      this.setState({ isImageLoading: true });

      const response = await http.get(`images/${selectedSchoolCode}/${img}`, {
        responseType: "blob",
      });

      this.revokeObjectUrl();

      this.objectUrl = URL.createObjectURL(response.data);

      this.setState({
        imageUrl: this.objectUrl,
        isImageLoading: false,
        loadedImg: img,
        loadedSchoolCode: selectedSchoolCode,
      });
    } catch (error) {
      console.error("Failed to load protected image:", error);

      this.revokeObjectUrl();

      this.setState({
        imageUrl: null,
        isImageLoading: false,
        loadedImg: img,
        loadedSchoolCode: selectedSchoolCode,
      });
    }
  };

  toggleStyle = (e, coords) => {
    let tmpCoordsObj = { ...this.state.coordsRefIsActive };

    for (const key in tmpCoordsObj) {
      tmpCoordsObj[key] = false;
    }

    this.setState(
      {
        coordsRefIsActive: {
          ...tmpCoordsObj,
          [coords.id]: !this.state.coordsRefIsActive[coords.id],
        },
      },
      () => {
        if (this.state.coordsRefIsActive[coords.id]) {
          this.props.setIdFunc(coords.id);
        } else {
          this.props.removeIdFunc();
        }

        this.setState({
          isSpaceClicked: !!this.state.coordsRefIsActive[coords.id],
        });
      }
    );

    e.preventDefault();
  };

  svgStyle = () => {
    const { imgHeight, imgWidth } = this.props;
    if (imgHeight - imgWidth > imgWidth) return { height: "45vh" };
    return { width: "45vw" };
  };

  render() {
    const {
      showAllSelectableArea,
      imgWidth,
      imgHeight,
      bookable,
      coordinates,
    } = this.props;

    const { imageUrl } = this.state;

    return (
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox={`0 0 ${imgWidth} ${imgHeight}`}
          style={this.svgStyle()}
        >
          {imageUrl ? (
            <image width={imgWidth} height={imgHeight} xlinkHref={imageUrl} />
          ) : null}

          {React.Children.toArray(
            coordinates.map((val) =>
              !bookable ? (
                <g
                  className={`${this.state.style} ${
                    showAllSelectableArea ? "allSelected" : ""
                  } ${
                    this.state.coordsRefIsActive[val.id]
                      ? "active-selected-area"
                      : ""
                  }`}
                  opacity="0"
                  onMouseOver={() => {
                    if (!this.state.isSpaceClicked) {
                      this.props.setIdFunc(val.id);
                    }
                  }}
                  onMouseOut={() => {
                    if (!this.state.isSpaceClicked) {
                      this.props.removeIdFunc();
                    }
                  }}
                  onClick={(e) => this.toggleStyle(e, val)}
                  onDoubleClick={(e) => {
                    if (this.props.id === null) {
                      this.toggleStyle(e, val);
                    }
                    this.props.goToSelected();
                  }}
                >
                  <path
                    className={`pathSpecificArea ${
                      showAllSelectableArea &&
                      !this.state.coordsRefIsActive[val.id]
                        ? "showAllSelectable"
                        : ""
                    }`}
                    stroke="black"
                    strokeWidth="1"
                    opacity="0.5"
                    d={val.coords}
                  />
                </g>
              ) : (
                <g
                  opacity="0"
                  className={this.state.style}
                  onClick={(e) => this.toggleStyle(e, val)}
                >
                  <path
                    className="not-bookable pathSpecificArea"
                    stroke="black"
                    strokeWidth="1"
                    opacity="0.5"
                    d={val.coords}
                  />
                </g>
              )
            )
          )}
        </svg>
      </div>
    );
  }
}

SpecificArea.contextType = GlobalContext;

export default SpecificArea;
